import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { navigateToAuthServer } from 'Utils/UtilityFunctions';
import { actions } from '../../../Slice/LoginSlice';
import Button from './Button';

const LoginWrapper = styled.div`
  margin: 0px;
  padding: 50px 60px;
  border-radius: 30px;
  background-color: #fff;
  display: block;
  width: 100%;
  position: relative;
  @media all and (max-width: 1439px),
    (max-height: 729px),
    (-webkit-device-pixel-ratio: 1.25) {
    border-radius: 21px;
    padding: 0px 40px 30px 40px;
    max-width: 400px;
  }
  @media all and (max-width: 786px) {
    min-width: 268px;
    text-align: center;
    padding: 0px 75px 20px 75px
  }
  @media all and (max-width: 440px) {
    padding: 0px 10px 20px 10px;
  }
  .cross-btn {
    position: absolute;
    right: 18px;
    top: 20px;
    cursor: pointer;
    @media all and (max-width: 1439px),
      (max-height: 729px),
      (-webkit-device-pixel-ratio: 1.25) {
      top: 12px;
    }
    svg {
      @media all and (max-width: 1439px),
        (max-height: 729px),
        (-webkit-device-pixel-ratio: 1.25) {
        width: 23px;
        height: 23px;
      }
    }
  }
  .content-wrapper {
    margin-top: 75px;
    margin-bottom: 0px;
    h2 {
      margin-top: 30px;
      font-family: "Roboto Slab";
      @media all and (max-width: 786px) {
        margin-top: 20px;
      }
    }
    @media all and (max-width: 786px) {
     margin-top: 0px;
     margin-bottom: 0px; 
    }
  }
  .input-field-spacing {
    margin-top: 50px;
    margin-bottom: 70px;
    @media all and (max-width: 786px) {
     margin-top: 0px;
     margin-bottom: 0px; 
    }
  }
  h2 {
    color: #424b50;
    font-size: 54px;
    margin: 64px 0 10px 0;
    font-weight: bold;
    text-align: left;
    @media all and (max-width: 1439px),
      (max-height: 729px),
      (-webkit-device-pixel-ratio: 1.25) {
      font-size: 26px;
      margin: 25px 0 10px 0;
    }
    @media all and (max-width: 786px ) {
      text-align: center;
      margin-bottom: 0px;
    }
  }

  p {
    font-size: 16px;
    color: #5e7079;
    margin: 27px 0;
    font-family: "Roboto";
    font-weight: 600;
    @media all and (max-width: 1439px),
      (max-height: 729px),
      (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      margin: 16px 0;
    }
    @media all and (max-width: 786px) {
      font-weight: unset;
      margin: 8px 0px 24px 0px;
    }
    a {
      color: #1EC252 !important;
      font-weight: 700;
      text-decoration: none;
    }
  }
  .line-height-56{
    line-height: 56px;
  }
`;

const PasswordUpdated: React.FC = function PasswordUpdated() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.resetForgetPassword(false));
  }, []);
  return (
    <LoginWrapper>
      <div className="content-wrapper">
        <div className="input-field-spacing">
          <h2 className="line-height-56">Password Updated!</h2>
          <p>
            Your password has been successfully updated.
          </p>
        </div>
      </div>

      <Button value="Go to my account" onClickButton={() => navigateToAuthServer()} />
    </LoginWrapper>
  );
};

export default PasswordUpdated;
